import React, { useState, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, Redirect, useHistory } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function ForgotPassword() {
  const { register, handleSubmit, errors } = useForm();
  const { isAuthenticated, userLogin, isLoading } = useContext(AuthContext);
  const history = useHistory();

  useEffect(() => {
    if (isAuthenticated) {
      $("#sign_up_popup3").modal("hide");
      history.push("/profile?tab=dashboard");
    }
  }, [isAuthenticated]);

  const onSubmit = async (value) => {
    await userLogin(value);
  };

  return (
    <div
      className="modal fade twm-sign-up"
      id="sign_up_popup3"
      aria-hidden="true"
      aria-labelledby="sign_up_popupLabel2"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h2 className="modal-title" id="sign_up_popupLabel2">
                Forgot Password
              </h2>
              <p>
                Please provide us with your email address, and we will send you
                a link to initiate the password reset process.
              </p>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div id="login-candidate">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <input
                        name="email"
                        type="email"
                        required=""
                        placeholder="Email Address"
                        className={`form-control ${
                          errors.email !== undefined ? "is-invalid" : ""
                        }`}
                        ref={register({
                          required: "Email field is required.",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        })}
                      />
                      {errors.email && (
                        <div id="emailFeedback" className="text-danger">
                          {errors.email.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-12">
                    <button type="submit" className="site-button">
                      Submit
                    </button>
                    <div className="mt-3 mb-3">
                      Already registered?
                      <button
                        type="button"
                        className="twm-backto-login"
                        data-bs-target="#sign_up_popup2"
                        data-bs-toggle="modal"
                        data-bs-dismiss="modal"
                      >
                        Login
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span className="modal-f-title">Login or Sign up with</span>
              <ul className="twm-modal-social">
                <li>
                  <a href="javascript" className="facebook-clr">
                    <i className="ri-facebook-fill"></i>
                  </a>
                </li>
                <li>
                  <a href="javascript" className="twitter-clr">
                    <i className="ri-twitter-fill"></i>
                  </a>
                </li>
                <li>
                  <a href="javascript" className="linkedin-clr">
                    <i className="ri-linkedin-fill"></i>
                  </a>
                </li>
              </ul>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
